import { GlobalService } from './../../shared/global.service';
import { GedUserSummary } from './../../shared/models/ged-user-summary';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import { GedFile } from 'src/app/shared/models/gedFile';
import { GedGroup } from 'src/app/shared/models/gedGroup';
import { GedEntity } from 'src/app/shared/models/gedEntity';
import { GedFileType } from 'src/app/shared/models/gedFileType';
import { GedFrequency } from 'src/app/shared/models/gedFrequency';
import { GedRole } from 'src/app/shared/models/gedRole';
import { GedAccessControl } from 'src/app/shared/models/GedAccessControl';
import { AuthService } from '../user/auth.service';
import * as firebase from 'firebase';
import { flatMap, mergeMap, switchMap, map, filter, tap, take } from 'rxjs/operators';
import { of, Observable, empty } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class GedService {
  private baseAddress: string = '';
  private apiKey: string ='';
  private uid: string='';

  constructor(private af:AngularFireDatabase, private authService: AuthService,
    private globalService: GlobalService) {
      this.getApiKey();
  }

  async getApiKey(){
    await this.globalService.apiKey$.subscribe(val=>{
      this.apiKey = val;
      this.baseAddress = `ged/customers/${this.apiKey}`;
    })
    let da = await this.getDataAccess$().toPromise();
    console.log(da)
    return this.apiKey;
  }

   getDataAccess$(): Observable<any>{
     return this.globalService.apiKey$.pipe(
       filter(apiKey=>!!apiKey),
       tap(apiKey=>this.baseAddress = `ged/customers/${apiKey}`),
       switchMap(apiKey=>
          this.authService.user$.pipe(
            filter(uid=>!!uid),
            tap(user=>this.uid=user.uid),
            map(user=>({user,apiKey})))
       ))
  }


  public listGedFile():AngularFireList<GedFile>{
    return this.af.list(`${this.baseAddress}/files/`);
  }

  public listGedFileKey(key):AngularFireList<GedFile>{
    return this.af.list(`${this.baseAddress}/files/`, q=>q.orderByKey().equalTo(key));
  }

  public listGedFileCreatedBetween(startDate, endDate):AngularFireList<GedFile>{
    return this.af.list(`${this.baseAddress}/files/`,q=>q.orderByChild('createdAt').startAt(startDate).endAt(endDate));
  }

  public listGedUserFile():Observable<any>{//:AngularFireList<GedFile>{
    //return this.af.list(`${this.baseAddress}/userFiles/${this.uid}`)
    return this.getDataAccess$().pipe(
      flatMap( data=>{
        if (data){
          return this.af.list(`${this.baseAddress}/userFiles/${data.user.uid}`).snapshotChanges()
        } else {
          return empty();
        }
      })
    )
  }

  public listGedUserSummary():Observable<any>{


     return this.getDataAccess$().pipe(
        flatMap((data:any)=>{
          if (data){
            console.log(data)
            return this.af.object(`${this.baseAddress}/userSummary/${data.user.uid}`).valueChanges()
          } else {
            return empty();
          }
        })
      )

  }

  public listCustomer():Observable<any>{
    return this.getDataAccess$().pipe(
       flatMap((data:any)=>{
         if (data){
           return this.af.list(`_apiKey`,q=>q.orderByChild('apiKey').equalTo(data.apiKey)).valueChanges().pipe(
             take(1),
             map(items=>items[0])
           );
         } else {
           return empty();
         }
       })
     )

 }

  public listGedUserFilePaging(offset: number, startKey?: string, order?: string):AngularFireList<GedFile>{

    return this.af.list(`${this.baseAddress}/userFiles/${this.uid}`,
    q =>{
      if (startKey){
        return q.orderByChild('order')
        .startAt(order,startKey).limitToFirst(offset+1)
      } else {
        return q.orderByChild('order').limitToFirst(offset+1)
      }
    })
  }

  public async listGedUserFileKey(key):Promise<GedFile>{//AngularFireObject<GedFile>{
    //return this.af.list(`${this.baseAddress}/userFiles/${this.uid}`, q=>q.orderByValue().equalTo(key));
    let file;
   await this.af.database.ref(`${this.baseAddress}/userFiles/${this.uid}/${key}`).once('value').then((f) => {
    file = f.val();
    file['$key'] = f.key;
   })
   return file
    
    //return this.af.object(`${this.baseAddress}/userFiles/${this.uid}/${key}`);
  }
  

  public async saveGedUserFile(file:GedFile){
   // console.log(file.$key,`${this.baseAddress}/userFiles/${this.uid}`)
   let key = file.$key;
   delete file.$key;
   await this.af.database.ref(`${this.baseAddress}/userFiles/${this.uid}/${key}`).transaction((f:GedFile)=>{
     return file;
   })
  }

  public async saveGedUserFileMeasurement(file:GedFile){
    // console.log(file.$key,`${this.baseAddress}/userFiles/${this.uid}`)
    let key = file.$key;
    delete file.$key;
    await this.af.database.ref(`${this.baseAddress}/userFiles/${this.uid}/${key}`).transaction((f:GedFile)=>{
      f.measurementStatus = file.measurementStatus;
      f.measurementDesc = file.measurementDesc;
      return f;
    })
   }

  public listGedUserMonthFile(month):AngularFireList<GedFile>{
    return this.af.list(`${this.baseAddress}/userFiles/${this.uid}`, q => q.orderByChild('month').equalTo(month));
  }

  public listGedUserEntityFile(entityKey):AngularFireList<GedFile>{
    return this.af.list(`${this.baseAddress}/userFiles/${this.uid}`, q => q.orderByChild('entityKey').equalTo(entityKey));
  }

  public listGedUserGroupFile(groupKey):AngularFireList<GedFile>{
    return this.af.list(`${this.baseAddress}/userFiles/${this.uid}`, q => q.orderByChild('groupKey').equalTo(groupKey));
  }


  public listGedUserMonthEntityFile(monthEntityKey):AngularFireList<GedFile>{
    return this.af.list(`${this.baseAddress}/userFiles/${this.uid}`, q => q.orderByChild('monthEntityKey').equalTo(monthEntityKey));
  }

  public listGedUserMonthGroupFile(monthGroupKey):AngularFireList<GedFile>{
    return this.af.list(`${this.baseAddress}/userFiles/${this.uid}`, q => q.orderByChild('monthGroupKey').equalTo(monthGroupKey));
  }

  datetimestamp(date) {
    var today = new Date(date);
    var sToday = today.getDay().toString();
    sToday += '-' + (today.getMonth() + 1).toString();
    sToday += '-' + today.getFullYear().toString();
    sToday += '-' + today.getHours().toString();
    sToday += '-' + today.getMinutes().toString();
    return sToday;
  }

  getFileLink(f): Promise<any>{
    const {$key,name, createdAt} = f;
    var file ={
      fileName: `GedFiles/${this.apiKey}/${this.datetimestamp(createdAt)}_${name}`,
      fileKey:$key,
      apiKey:this.apiKey,
      uid:this.uid
    }
    console.log(file);
    var getFileLink = firebase.functions().httpsCallable('getFileLink');

    return getFileLink(file)
  }


  measure(status:string,desc:string,fileKey:string): Promise<any>{
  
    let data = {
      status,
      desc,
      fileKey,
      apiKey:this.apiKey,
      uid:this.uid
    }
    console.log(data);
    var fn = firebase.functions().httpsCallable('measure');

    return fn(data)
  }


  public saveGedFile(gedFile:GedFile){
    delete gedFile.progress;
    gedFile.monthEntityKey = `${gedFile.month}_${gedFile.entityKey}`;
    gedFile.monthGroupKey = `${gedFile.month}_${gedFile.groupKey}`;
    this.af.list(`${this.baseAddress}/files/`).push(gedFile);
  }

  public listGedGroup():AngularFireList<GedGroup>{
    return this.af.list(`${this.baseAddress}/group/`);
  }

  public listGedGroupKey(key):AngularFireObject<GedGroup>{
    return this.af.object(`${this.baseAddress}/group/${key}`);
  }

  public listGedEntityKey(key):AngularFireObject<GedEntity>{
    return this.af.object(`${this.baseAddress}/entity/${key}`);
  }



  public listGedUserGroup():Observable<any>{
    return this.getDataAccess$().pipe(
      flatMap( data=>{
        if (data){
          return this.af.list(`${this.baseAddress}/userGroup/${data.user.uid}`).snapshotChanges()
        } else {
          return empty();
        }
      })
    )
  }

  public saveGedGroup(getGroup:GedGroup){
    if (getGroup.$key){
      let key = getGroup.$key;
      delete getGroup.$key;
      this.af.list(`${this.baseAddress}/group/`).update(key,getGroup);
    } else {
      delete getGroup.$key;
      this.af.list(`${this.baseAddress}/group/`).push(getGroup);
    }
  }

  public listGedEntity():AngularFireList<GedEntity>{
    return this.af.list(`${this.baseAddress}/entity/`);
  }

  public listGedUserEntity():AngularFireList<GedEntity>{
    return this.af.list(`${this.baseAddress}/userEntity/${this.uid}`);
  }

  public listGedEntityObject(key:string):AngularFireObject<GedEntity>{
    return this.af.object(`${this.baseAddress}/entity/${key}`);
  }

  public saveGedEntity(getEntity:GedEntity){
    if (getEntity.$key){
      let key = getEntity.$key;
      delete getEntity.$key;
      this.af.list(`${this.baseAddress}/entity/`).update(key,getEntity);
    } else {
      delete getEntity.$key;
      this.af.list(`${this.baseAddress}/entity/`).push(getEntity);
    }
  }

  public deleteGedEntity(key){
    this.af.list(`${this.baseAddress}/entity/${key}`).remove();
  }


  public listGedGroupPaging(startAt,offSet):AngularFireList<GedGroup>{
    return this.af.list(`${this.baseAddress}/group/`,
    q=>q.orderByKey().limitToFirst(offSet)
    );
  }

  public listFileType():AngularFireList<GedFileType>{
    return this.af.list('ged/settings/fileType');
  }

  public listFrequency(): AngularFireList<GedFrequency>{
    return this.af.list('ged/settings/frequency');
  }

  public listRole(): AngularFireList<GedRole>{
    return this.af.list('ged/settings/role');
  }

  public listGedAccessControl():AngularFireList<GedAccessControl>{
    return this.af.list(`${this.baseAddress}/accessControl/`);
  }

  public listGedAccessControlByEntityKey(key:string):AngularFireList<GedAccessControl>{
    return this.af.list(`${this.baseAddress}/accessControl/`,
    q=>q.orderByChild('entityKey').equalTo(key));
  }


}
